export const objectToArray = obj => Object.keys(obj).map(key => obj[key])

export const createFieldMissingErrorMessage = obj => {
  let errorMessage = 'Missing Fields: '
  for (const field in obj) {
    if (!obj[field]) {
      const capitalizedField = field.charAt(0).toUpperCase() + field.slice(1)
      const spacedField = capitalizedField.replace(/[A-Z]/g, ' $&')
      errorMessage += `${spacedField}, `
    }
  }
  return errorMessage.slice(0, -2)
}

export const deepCopyJSON = item => JSON.parse(JSON.stringify(item))

export const momentHumanize = (eventMDuration) => {
  let eventDurationArray = []
  if (eventMDuration.years() > 0) {
    eventDurationArray.push(`${eventMDuration.years()} years`)
    eventMDuration.subtract(eventMDuration.years(), 'years')
  }
  if (eventMDuration.months() > 0) {
    eventDurationArray.push(`${eventMDuration.months()} months`)
    eventMDuration.subtract(eventMDuration.months(), 'months')
  }
  if (eventMDuration.weeks() > 0) {
    eventDurationArray.push(`${eventMDuration.weeks()} weeks`)
    eventMDuration.subtract(eventMDuration.weeks(), 'weeks')
  }
  if (eventMDuration.days() > 0) {
    eventDurationArray.push(`${eventMDuration.days()} days`)
    eventMDuration.subtract(eventMDuration.days(), 'days')
  }
  if (eventMDuration.hours() > 0) {
    eventDurationArray.push(`${eventMDuration.hours()} hours`)
    eventMDuration.subtract(eventMDuration.hours(), 'hours')
  }
  if (eventMDuration.minutes() > 0) {
    eventDurationArray.push(`${eventMDuration.minutes()} mins`)
  }
  return eventDurationArray.length === 1 ? eventDurationArray[0] :
  eventDurationArray.join(' and ')
}



// WEBPACK FOOTER //
// ./src/utils/helperFunction.js